export default "__VITE_ASSET__BsK6MVDW__"